import { useEffect, useState } from "react";
import CourseOverview from "./CourseOverview";
import InstituteDetails from "./InstituteDetails";
import EntryRequirement from "./EntryRequirement";
import StepToAdmission from "./StepToAdmission";
import StudyCost from "./StudyCost";
import AboutCountry from "./AboutCountry";
import { ChevronLeft, MapPin } from "lucide-react";
import { courseDetails } from "../../../api/courseDetails";
import { useParams, useNavigate } from "react-router-dom";

const decryptId = (encryptedId) => {
  return atob(encryptedId); // Base64 decode
};

export default function CourseDetails() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState("course");
  const [data, setData] = useState(null);

  const realCourseId = decryptId(courseId);

  const fetchCourseDetails = async () => {
    try {
      const res = await courseDetails({ course_id: realCourseId });
      setData(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (courseId) fetchCourseDetails();
  }, [courseId]);

  if (!data) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 pb-16 font-inter">
      <button
        onClick={() => navigate(-1)}
        className="text-[#572575] font-bold flex items-center mb-4"
      >
        <ChevronLeft /> Courses Details
      </button>

      {/* Banner */}
      <div className="relative rounded-2xl overflow-hidden mb-8">
        <img src="/CD.png" className="object-cover" />
        <div className="absolute inset-0 top-28 flex items-end p-6">
          <div>
            <h1 className="text-3xl font-bold text-white">
              {data.courseDetails.course_name}
            </h1>
            <p className="text-white text-sm flex items-center mt-1">
              <MapPin /> {data.instituteDetails.university_name},{" "}
              {data.instituteDetails.country_name}
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-3 mb-8">
        {[
          ["course", "Course Details"],
          ["institute", "Institute Details"],
          ["entry", "Entry Requirement"],
          ["admission", "Step to Admission"],
          ["cost", "Study Cost"],
          ["country", "About Canada"],
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={`px-4 py-2 rounded-lg border text-sm font-medium ${
              tab === key
                ? "bg-[#F8EDFF80] text-[#9D0385] border-[#DFACFE]"
                : "bg-white hover:bg-gray-50"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === "course" && <CourseOverview data={data} />}
      {tab === "institute" && <InstituteDetails data={data} />}
      {tab === "entry" && <EntryRequirement data={data} />}
      {tab === "admission" && <StepToAdmission data={data} />}
      {tab === "cost" && <StudyCost data={data} />}
      {tab === "country" && <AboutCountry data={data} />}
    </div>
  );
}
